export const MOBILE_APP_VERSION_API_ENDPOINTS = {
	ADD_MOBILE_APP_VERSION: "/cms/add-mobile-app-version",
	UPDATE_MOBILE_APP_VERSION: "/cms/update-mobile-app-version",
	GET_MOBILE_APP_VERSION: "/cms/get-mobile-app-version-details",
};

export interface MobileAppVersionData {
	platform: string;
	version: string;
	hasWarning: boolean;
	forceUpdate: boolean;
	appId: number | undefined;
	versionId?: string;
}

export const defaultMobileAppVersionData: MobileAppVersionData = {
	platform: "",
	version: "",
	hasWarning: false,
	forceUpdate: false,
	appId: undefined,
	versionId: ""
};